import { IPowerbarStoreModule, registerAdapter, unregisterAdapter } from '../utils'
import { ISidebarState } from './types'
import getters from './getters'
import mutations from './mutations'
import actions from './actions'
import state from './state'

const SidebarState: IPowerbarStoreModule<ISidebarState, any> = {
  name: 'SidebarState',
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

SidebarState.register = registerAdapter(SidebarState);
SidebarState.unregister = unregisterAdapter(SidebarState);

export default SidebarState

